import { Spin, Tabs } from 'antd';
import CarDocumentSections from 'containers/CarProfile/CarDocumentSections';
import CarProfileHeader from 'containers/CarProfile/CarProfileHeader';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';
import { Component } from 'react';
import { CarStore, ShopStore } from 'stores';
import { CarObject } from 'stores/Classes';
import styled from 'styled-components';
import AssetWorkOrders from './AssetWorkOrders';

const { TabPane } = Tabs;

const VehicleHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
  > p {
    font-size: 14px;
    margin: 0 20px;
  }
  > p > strong {
    font-size: 20px;
  }
`;

const StickyTabsWrapper = styled.div`
  .ant-tabs-nav {
    position: sticky;
    top: 64px;
    background: white;
    z-index: 4;
  }
`;

class TrailerProfilePage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    car: PropTypes.instanceOf(CarObject),
  };

  constructor(props) {
    super(props);

    makeObservable(this, {
      shopId: computed,
    });

    const selector = props.match.params.selector;
    const activeKey = selector
      ? selector.toNormalString().capitalizeFirstLetter()
      : 'General';

    this.state = {
      activeKey,
    };
  }

  get car() {
    return CarStore.data.get(Number(this.props.match.params.id));
  }

  get shopId() {
    return ShopStore.currentShop.id === -1
      ? this.car?.shopId
      : ShopStore.currentShop.id;
  }

  async componentDidMount() {
    const carId = Number(this.props.match.params.id);
    if (!CarStore.data.has(carId)) {
      await CarStore.getCarById(carId);
    }

    const car = CarStore.data.get(carId);
    if (car?.carType?.toLowerCase() === 'vehicle') {
      this.props.history.replace(`/car/${carId}`);
    }
  }

  getTabs = (car) => {
    const panels = [
      <TabPane tab="General" key="General">
        <CarProfileHeader car={car} shopId={this.shopId} />
      </TabPane>,
      <TabPane tab="Work Orders" key="Work Orders">
        <AssetWorkOrders car={car} shopId={this.shopId} />
      </TabPane>,
      <TabPane tab="Documents" key="Documents">
        <CarDocumentSections car={car} />
      </TabPane>,
    ];

    return panels.map((el) =>
      el.key === this.state.activeKey ? (
        el
      ) : (
        <TabPane tab={el.key} key={el.key} />
      )
    );
  };

  changeTab = (activeKey) => {
    this.props.history.replace(
      `/trailer/${this.props.match.params.id}/${activeKey.toReadableUrl()}`
    );
    this.setState({ activeKey });
  };

  carNameFrag(car) {
    const { carName } = car;
    return carName && <p>{`Unit Id: ${carName}`}</p>;
  }

  render() {
    if (!this.car || !this.car.loaded) {
      return <Spin size="large" tip="Loading..." />;
    }

    return (
      <div
        style={{
          maxHeight: '100%',
          minWidth: '77%',
          marginTop: 10,
        }}
      >
        <VehicleHeaderContainer>
          <p style={{ fontSize: '20px' }}>
            <strong>{`${this.car.mmy}`}</strong>
          </p>
          {this.carNameFrag(this.car)}
        </VehicleHeaderContainer>

        <StickyTabsWrapper>
          <Tabs
            defaultActiveKey={this.state.activeKey}
            size="large"
            onChange={this.changeTab}
          >
            {this.getTabs(this.car)}
          </Tabs>
        </StickyTabsWrapper>
      </div>
    );
  }
}

export default observer(TrailerProfilePage);
